import React, { useState, useEffect, useRef } from 'react';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, } from '@fortawesome/free-solid-svg-icons';
import Cargoplane from "../../../../assets/images/plane.svg";
import show from '../../../../assets/images/show.png';
import message_icon from "../../../../assets/images/Message_2.png";
import file_download from "../../../../assets/images/file_download.png";
import Docmnt from "../../../../assets/images/google-docs.png";
import { toast } from 'react-toastify';
import { saveAs } from "file-saver";

import NewTask from './NewTask.js';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { SAVERECOVERY } from '../../../../Utils/conts.js';
import { getTodayDate } from '../../../../Components/common/CommonFunctions.js';

const Overview = ({ allData, spec, cat, sol, onChildAction, onTab }) => {
    // console.log("🚀 ~ Overview ~ allData:", allData)

    const isMounted = useRef(false);
    const [recoveryAspects, setRecoveryAspects] = useState([]);
    const [assignUserOpt, setAssignUserOpt] = useState([]);
    const [priorityOpt, setPriorityOpt] = useState([]);
    const [subStatusOpt, setSubStatus] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [formData, setFormData] = useState({});
    const [isEditable, setIsEditable] = useState(false);
    const [reportedStn, setReportedStn] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [activeEditId, setActiveEditId] = useState(null);
    const org_id = JSON.parse(localStorage.getItem("Handler_stn")).org_id;
    const [attHandler, setAttHandler] = useState([]);
    const fetchDropdown = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/dropdown-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setCommodityType(innerData.commodity_type);
                    // setMovementType(innerData.movement_type);
                    setRecoveryAspects(innerData.recovery_aspects);
                    // setRecoveryInfo(innerData.recovery_information);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAssignUser = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/assign-user-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setAssignUserOpt(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchPriority = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '19' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setPriorityOpt(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSubStatus = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '20' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSubStatus(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchTaskList = async () => {
        try {

            const res = await withRFSToken.get(`task/list?tab=A&taskable_id=${allData.service_recovery_id}&taskable_type=service_recovery`)
                .then(function (res) {
                    const innerData = res.data.Rows;
                    setTaskList(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (isMounted.current) return;
        fetchDropdown();
        // fetchAssignUser();
        // fetchPriority();

        // fetchSubStatus();
        isMounted.current = true;
    }, []);

    // let attHandler;
    useEffect(() => {
        if (allData) {
            setFormData({
                assign_to: allData?.assign_to || null,
                assign_to_type: allData?.assign_to_type || '',
                priority_id: allData?.priority_id || null,
                sub_status_id: allData?.sub_status_id || null,
            })
            fetchTaskList();
            // const rstn = allData?.stations?.find(type => type.handler_type == 'Reported');
            let rstn = allData?.stations?.find(type => type.org_id == org_id);

            const newAspect = {
                warehouse_check: false, warehouse_check_date: '', spot_check: false, spot_check_date: '',
                agent_check: false, agent_check_date: '', cctv_check: false, cctv_check_date: '',
            };
            if (rstn?.handler_action?.length == 0) {
                rstn = { ...rstn, handler_action: [newAspect] }
            } else {
                rstn = { ...rstn }
            }

            setReportedStn(rstn)
            const attHandler = allData?.attachments?.filter(
                (att) => att.uploaded_by_org_id === rstn?.org_id
            );
            setAttHandler(attHandler)
        }
    }, [allData]);

    const [openTaskModal, setOpenTaskModal] = useState(false);
    const openDefineTask = () => {
        setOpenTaskModal(true)
    }
    const reloadGrid = () => {
        // onChildAction()
        fetchTaskList();
        setOpenTaskModal(false)
    }
    const closeNewTask = () => {
        setOpenTaskModal(false)
    };

    // const dropdownChange = (name, value) => {
    //     console.log('sasaas', value);
    //     if (name == 'assign_to') {
    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: value.value,
    //             assign_to_type: value.type,
    //         }))
    //     } else {
    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: value,
    //         }))
    //     }

    // }

    // const handleToggleEdit = () => {
    //     if (isEditable) {
    //         handleFinish();
    //         setIsEditable(false)
    //     } else {
    //         setIsEditable(true)
    //     }
    // }

    // const handleFinish = async () => {
    //     const getOrigin = allData.stations.find(i => i.handler_type == 'Origin');
    //     const getDest = allData.stations.find(i => i.handler_type == 'Destination');
    //     const transformedData = {
    //         ...allData,
    //         origin_notify_status: allData.origin_notify_status == true ? 1 : 0,
    //         destination_notify_status: allData.origin_notify_status == true ? 1 : 0,
    //         all_stations: [
    //             {
    //                 handler_feedback_id: getOrigin.handler_feedback_id,
    //                 station_name: allData.origin,
    //                 handler_id: allData.origin_handler_id,
    //                 notify_status: allData.origin_notify_status == true ? 1 : 0
    //             },
    //             {
    //                 handler_feedback_id: getDest.handler_feedback_id,
    //                 station_name: allData.destination,
    //                 handler_id: allData.destination_handler_id,
    //                 notify_status: allData.destination_notify_status == true ? 1 : 0
    //             },
    //             ...allData.all_stations
    //         ],
    //         ...formData
    //         // files: [
    //         //     ...(formData.files || []),
    //         //     ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
    //         //     ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
    //         // ]
    //     };
    //     try {
    //         const res = await withRFSToken.post(SAVERECOVERY, transformedData)
    //             .then(function (res) {
    //                 // setIsLoading(false);
    //                 if (res.data.response_code == 200) {
    //                     toast.success(res.data.response_msg);
    //                     setIsEditable(false)
    //                     onChildAction();
    //                 } else {
    //                     toast.error(res.data.response_msg);
    //                 }
    //             });

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    const viewTask = (dta) => {
        localStorage.setItem('rowId', JSON.stringify(dta.id));
        window.location.href = "/EditTask";
    };

    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };
        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {imageUrl ?
                    <img
                        src={imageUrl}
                        alt={label}
                        style={{
                            width: 18,
                            height: 18,
                            objectFit: 'cover',
                            borderRadius: 4,
                            marginRight: 10
                        }}
                    />
                    : ''
                }

                <span>{label}</span>
            </div>
        );
    };

    const handleImageTab = () => {
        onTab('at')
    }
    const handleMsgTab = (sec) => {
        onTab({ tab: 'msg', goTo: sec })
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }

    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        console.log('path', path);

        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: imageUrl,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };
    const handleEditToggle = async (station) => {
        const serviceRecoveryId = allData?.service_recovery_id;
        if (activeEditId !== station.handler_feedback_id) {
            setActiveEditId(station.handler_feedback_id);
            return;
        }
        const payload = {
            station: [
                {
                    ...station,
                    pieces_traced: station.pieces_traced ?? '',
                    tracing_date: station.tracing_date ?? '',
                    storage_location: station.storage_location ?? '',
                    acceptance_time: station.acceptance_time ?? '',
                    buildup_time: station.buildup_time ?? ''
                }
            ],
            service_recovery_id: serviceRecoveryId
        };
        try {
            setIsLoading(true);
            const res = await withRFSToken.post('service-recovery/update', payload);
            if (res?.data?.response_code === 200) {
                toast.success('Station updated');
                setActiveEditId(null);
                onChildAction?.();
            } else {
                toast.error(res?.data?.response_msg || 'Update failed');
            }
        } catch (error) {
            console.error("Error updating station:", error);
            toast.error('Unable to update station');
        } finally {
            setIsLoading(false);
        }
    };

    const reportedIsEditing = activeEditId === reportedStn?.handler_feedback_id;

    const handleReportedFormChange = (field, value) => {
        setReportedStn((prev) => ({ ...prev, [field]: value }));
    };

    const CHECK_DATE_MAP = {
        warehouse_check: 'warehouse_check_date',
        spot_check: 'spot_check_date',
        agent_check: 'agent_check_date',
        cctv_check: 'cctv_check_date',
    };

    const handleInputChange = (index, field, value) => {

        setReportedStn(prev => {
            const actions = [...prev.handler_action];
            const action = { ...actions[index], [field]: value };

            const dateField = CHECK_DATE_MAP[field];

            if (dateField) {
                if (value && !action[dateField]) {
                    action[dateField] = getTodayDate();
                } else if (!value) {
                    action[dateField] = '';
                }
            }

            actions[index] = action;

            return {
                ...prev,
                handler_action: actions
            };
        });
    };

    const handleReportedActionChange = (index, field, value) => {
        setReportedStn((prev) => {
            const updatedActions = [...(prev?.handler_action || [])];
            updatedActions[index] = { ...(updatedActions[index] || {}), [field]: value };
            return { ...prev, handler_action: updatedActions };
        });
    };

    return (
        <>
            {/* {console.log("🚀 :xxxxxxxxxx", reportedStn)} */}
            {/* {console.log("🚀 ~ Overview ~ assignUserOpt:", assignUserOpt)} */}
            {openTaskModal &&
                <NewTask
                    onReload={reloadGrid}
                    onClose={closeNewTask}
                    OData={{ taskable_id: allData.service_recovery_id, taskable_type: 'service_recovery' }}
                />
            }
            <Row>
                <Col sm={8}>
                    {/* <div className='flbg mb-3'>
                        <div className='overview_head'>
                            <h4 className='d-flex w-100 align-items-center justify-content-between'>
                                Fields (Actions)
                                <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                                    <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                                </button>
                            </h4>
                            <p></p>
                        </div>
                        <div className='fld-sl'>
                            <Row className='mb-2'>
                                <Col lg="4">
                                    <Form.Label>Assign User:</Form.Label>
                                </Col>
                                <Col lg="8">
                                    <Select
                                        options={assignUserOpt}
                                        onChange={(selected) => dropdownChange('assign_to', selected)}
                                        placeholder="Select"
                                        // className='autoslct'
                                        name='assign_to'
                                        value={assignUserOpt.find(group => group.label === formData.assign_to_type)?.options.find(opt => opt.value === formData.assign_to) || null}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                            </Row>
                            <Row className='mb-2'>
                                <Col lg="4">
                                    <Form.Label>Priority:</Form.Label>
                                </Col>
                                <Col lg="8">
                                    <Select
                                        options={priorityOpt}
                                        onChange={(selected) => setFormData(prev => ({ ...prev, priority_id: selected.value }))}
                                        placeholder="Select"
                                        // className='autoslct'
                                        name='priority_id'
                                        value={priorityOpt.find(option => option.value === formData.priority_id) || ''}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                            </Row>
                            <Row className='mb-2'>
                                <Col lg="4">
                                    <Form.Label>Sub Status:</Form.Label>
                                </Col>
                                <Col lg="8">
                                    <Select
                                        options={subStatusOpt}
                                        onChange={(selected) => setFormData(prev => ({ ...prev, sub_status_id: selected.value }))}
                                        placeholder="Select"
                                        // className='autoslct'
                                        name='sub_status_id'
                                        value={subStatusOpt.find(option => option.value === formData.sub_status_id) || ''}
                                        formatOptionLabel={formatOptionLabel}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div> */}
                    <Row>
                        <Col sm={6}>
                            <div className='flbg mb-3 outside_hglt'>
                                <div className='overview_head position-relative'>

                                    <h4>Highlighted Image</h4>
                                    <p>All AWB highlighted Images</p>

                                    <div className='crt-lk'> <Link to='#' onClick={handleImageTab}>Attach</Link> </div>
                                </div>
                                <div className='d-flex'>
                                    {allData?.attachments?.filter(item => item.primary === 1).map((item, index) => (
                                        <div className='image_part'>
                                            {/* {allData?.attachments?.find(dta => dta.primary === 1) &&
                                        <img src={allData?.attachments?.find(dta => dta.primary === 1)?.file_path} style={{ width: '100%' }} />
                                    } */}
                                            <img key={index} src={item.file_path} style={{ width: '100%' }} />
                                        </div>
                                    ))}
                                </div>
                                {/* <div className='inner_hglt'>
                            <div className='image_part'>
                                {allData?.attachments?.find(dta => dta.primary === 1) &&
                                <img src={allData?.attachments?.find(dta => dta.primary === 1)?.file_path} style={{ width: '100%' }} />
                                }
                            </div>
                            <div className='text_part'>
                                 <h4>Highlighted Image</h4>
                            <p>All AWB highlighted Images</p>

                            </div>
                        </div> */}

                            </div>
                            <div className='flbg mb-3'>
                                <div className='overview_head'>
                                    <h4>Shipment Information</h4>
                                    <p>AWB Details & Recovery Aspects</p>
                                </div>
                                <div className='mawb-list'>
                                    <ul>
                                        <li>
                                            <span>MAWB</span>
                                            <span>: {allData?.master_airway_bill_prefix}-{allData?.master_airway_bill_no}</span>
                                        </li>
                                        <li>
                                            <Row className='ttl_invold'>
                                                <Col sm={6}>
                                                    <span>Nature of goods</span>
                                                    <span>: {allData?.nature_of_goods}</span>
                                                </Col>
                                                <Col sm={6}>
                                                    <span>CUS</span>
                                                    <span>: {allData?.cus}</span>
                                                </Col>
                                            </Row>
                                        </li>
                                        <li>
                                            <span>SHC</span>
                                            <span>: {allData?.shc_name}</span>
                                        </li>
                                        <li>
                                            <Row className='ttl_invold'>
                                                <Col sm={6}>
                                                    <span>Total Pieces</span>
                                                    <span>: {allData?.total_mawb_pieces}</span>
                                                </Col>
                                                <Col sm={6}>
                                                    <span>Total Weight</span>
                                                    <span>: {allData?.total_mawb_wght}</span>
                                                </Col>
                                            </Row>
                                        </li>
                                        <li>
                                            <Row className='ttl_invold'>
                                                <Col sm={6}>
                                                    <span>Pieces Involved</span>
                                                    <span>: {allData?.pieces_involved}</span>
                                                </Col>
                                                <Col sm={6}>
                                                    <span>Weight Involved</span>
                                                    <span>: {allData?.pieces_wght}</span>
                                                </Col>
                                            </Row>
                                        </li>
                                        <li>
                                            <span>Recovery Aspects</span>
                                            <span>: {allData?.recovery_aspects_name}{/* allData?.recovery_aspects.map(ra => recoveryAspects?.find(opt => opt.value == ra).label) */}</span>
                                        </li>
                                        {allData?.recovery_aspects_others_name &&
                                            <li>
                                                <span>Other Aspects</span>
                                                <span>: {allData?.recovery_aspects_others_name}</span>
                                            </li>
                                        }
                                    </ul>
                                </div>

                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className='flbg mb-3 overview_taskList_dv'>
                                <div className='overview_head position-relative'>
                                    <h4>Tasks List</h4>
                                    <p>Overview of open task(s)</p>
                                    <div className='crt-lk'> <Link to='#' onClick={openDefineTask}>+ Create Task</Link></div>
                                </div>
                                <div className='new_task'>
                                    <div className='tsk-mn'>
                                        <ul>
                                            {taskList?.map((list, index) => (
                                                <li>
                                                    <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                                                        <h4><span><img src={show} alt="" onClick={() => viewTask(list)} /></span> {list.title} </h4>
                                                        <span className='inp org-cl'>{list.status_label}</span>
                                                    </div>
                                                    <div className='psn d-flex justify-content-between align-items-center'>
                                                        <span>{list.assign_name}</span>
                                                        <span>{list.due_date}</span>
                                                    </div>
                                                </li>
                                            ))}
                                            {/* <li>
                                    <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                                        <h4><span><img src={show} alt="" /></span> Task Name </h4>
                                        <span className='inp org-cl'>In Progress</span>
                                    </div>
                                    <div className='psn d-flex justify-content-between align-items-center'>
                                        <span>A person</span>
                                        <span>10-09-2025</span>
                                    </div>
                                </li>
                                <li>
                                    <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                                        <h4><span><img src={show} alt="" /></span> Task Name </h4>
                                        <span className='inp gry-cl'>Open</span>
                                    </div>
                                    <div className='psn d-flex justify-content-between align-items-center'>
                                        <span>Open</span>
                                        <span>10-09-2025</span>
                                    </div>
                                </li>
                                <li>
                                    <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                                        <h4><span><img src={show} alt="" /></span> Task Name </h4>
                                        <span className='inp gry-cl'>Open</span>
                                    </div>
                                    <div className='psn d-flex justify-content-between align-items-center'>
                                        <span>Open</span>
                                        <span>10-09-2025</span>
                                    </div>
                                </li>
                                <li>
                                    <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                                        <h4><span><img src={show} alt="" /></span> Task Name </h4>
                                        <span className='inp org-cl'>In Progress</span>
                                    </div>
                                    <div className='psn d-flex justify-content-between align-items-center'>
                                        <span>A person</span>
                                        <span>10-09-2025</span>
                                    </div>
                                </li> */}
                                        </ul>
                                    </div>

                                </div>

                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <div className='flbg avtr_height'>
                                <div className='overview_head'>
                                    <h4>Activity Comments</h4>
                                    <p>All Activity Comments for this AWB.</p>
                                </div>
                                {allData?.activities?.comments.length > 0 &&
                                    <>
                                        <div className='wh_activity'>
                                            {allData?.activities?.comments?.map((cmt, index) => (

                                                <div className='racomment' key={`cmt_${index}`}>
                                                    <div className='d-flex justify-content-between'>
                                                        <h3>{cmt?.created_by}</h3>
                                                        <span>{cmt?.created_at}</span>
                                                    </div>
                                                    <div className='middlebrd'>
                                                        <span dangerouslySetInnerHTML={{ __html: cmt?.message || '' }}></span>
                                                    </div>
                                                </div>



                                            ))}
                                        </div>
                                    </>
                                }

                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className='flbg h-100'>
                                <div className='overview_head'>
                                    <h4>Summary <span className='ai_name'>AI</span></h4>
                                    <p></p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                {/* {org_id == reportedStn?.org_id && */}
                <Col sm={4}>
                    <div className='flbg mb-3 h-100'>
                        <div className='ship_head'>
                            <h4 className='d-flex w-100 align-items-center justify-content-between'>
                                {reportedStn?.handler_type}
                                {reportedStn?.isEditable && (
                                    <button
                                        type='button'
                                        className='serv_edit_save ms-2'
                                        onClick={() => handleEditToggle(reportedStn)}
                                        disabled={isLoading}
                                    >
                                        <FontAwesomeIcon icon={faPencilAlt} className='pe-1' />
                                        {reportedIsEditing ? 'Save' : 'Edit'}
                                    </button>
                                )}
                            </h4>
                        </div>
                        <div className='recover_box mb-2'>
                            <div className='d-flex justify-content-between align-items-center up_reco_status'>
                                <div className='reco_left'>
                                    <h4>{reportedStn?.station_name}</h4>
                                    <p>{reportedStn?.handler_name}</p>
                                </div>
                                <div className='reco_middle'>
                                    <span className={reportedStn?.pieces_traced == null ? '' : reportedStn?.pieces_traced == allData.pieces_involved ? 'serv_trace_gr' : 'serv_trace_org'}>
                                        {reportedStn?.pieces_traced == null ? 'No Response' : reportedStn?.pieces_traced == allData.pieces_involved ? 'All Completed' : `${reportedStn?.pieces_traced}/${allData.pieces_involved} Pcs Traced`}</span>

                                </div>
                                <div className='reco_right'>
                                    <Link to='#' onClick={() => handleMsgTab(reportedStn?.station_name)}><img src={message_icon} alt='message_icon' /></Link>
                                </div>
                            </div>
                        </div>
                        <Form.Group as={Row} className="mb-1">
                            <Col >
                                <Form.Label>Pieces Traced</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder=""
                                    name='pieces_traced'
                                    value={reportedStn?.pieces_traced || ''}
                                    disabled={!reportedIsEditing}
                                    onChange={(e) => handleReportedFormChange('pieces_traced', e.target.value)}
                                />
                            </Col>
                            <Col >
                                <Form.Label>Tracing Date </Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder=""
                                    name='tracing_date'
                                    value={reportedStn?.tracing_date || ''}
                                    disabled={!reportedIsEditing}
                                    onChange={(e) => handleReportedFormChange('tracing_date', e.target.value)}

                                />
                            </Col>
                        </Form.Group>
                        <div className='specific_box'>
                            <Form.Group className='mb-2'>
                                <Form.Label>Short Description </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name='description'
                                    value={reportedStn?.description || ''}
                                    onChange={(e) => handleReportedFormChange('description', e.target.value)}
                                    placeholder="Short Description"
                                    style={{ height: '150px' }}
                                    disabled={!reportedIsEditing}
                                />
                            </Form.Group>

                            <Form.Group className='mb-2'>
                                <Form.Label>Specification <span>*</span></Form.Label>
                                <Select
                                    options={spec}
                                    className="basic-multi-select"
                                    value={spec.filter(opt => reportedStn?.specification?.includes(opt.value))}
                                    onChange={(selectedOptions) => {
                                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        handleReportedFormChange('specification', values);
                                    }}
                                    placeholder="Select"
                                    isDisabled={!reportedIsEditing}
                                    isMulti
                                />
                            </Form.Group>
                            <Form.Group className='mb-2'>
                                <Form.Label>Solution <span>*</span></Form.Label>
                                <Select
                                    options={sol}
                                    className="basic-multi-select"
                                    value={sol.filter(opt => reportedStn?.solution_id?.includes(opt.value))}
                                    onChange={(selectedOptions) => {
                                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        handleReportedFormChange('solution_id', values);
                                    }}
                                    placeholder="Select"
                                    isDisabled={!reportedIsEditing}
                                    isMulti
                                />
                            </Form.Group>
                        </div>
                        <div>
                            {/* <Form.Label>Recovery Aspects </Form.Label> */}
                            <Form.Group className="mb-1 mt-3">
                                {reportedStn?.handler_action?.map((aspect, index) => (
                                    <React.Fragment key={index}>
                                        <Row>
                                            <Col className='mb-2'>
                                                <div className='warehose'>
                                                    <Form.Check
                                                        inline
                                                        type="checkbox"
                                                        id={`warehouseCheck${index}`}
                                                        className="warehouse_check"
                                                        label='Warehouse Check'
                                                        checked={aspect.warehouse_check}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'warehouse_check', e.target.checked)}
                                                    />
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name="warehouse_check_date"
                                                        value={aspect.warehouse_check_date}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'warehouse_check_date', e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col className='mb-2 position-relative'>
                                                <div className='warehose'>
                                                    <Form.Check
                                                        inline
                                                        type="checkbox"
                                                        id={`spotcheck${index}`}
                                                        className="spot_check"
                                                        label='Spot Check'
                                                        checked={aspect.spot_check}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'spot_check', e.target.checked)}
                                                    />
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name="spot_check_date"
                                                        value={aspect.spot_check_date}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'spot_check_date', e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='mb-2'>
                                                <div className='warehose'>
                                                    <Form.Check
                                                        inline
                                                        type="checkbox"
                                                        id={`agentcheck${index}`}
                                                        className="agent_check"
                                                        label='Agent Check'
                                                        checked={aspect.agent_check}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'agent_check', e.target.checked)}
                                                    />
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name="agent_check_date"
                                                        value={aspect.agent_check_date}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'agent_check_date', e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col className='mb-2 position-relative'>
                                                <div className='warehose'>
                                                    <Form.Check
                                                        inline
                                                        type="checkbox"
                                                        id={`cctvcheck${index}`}
                                                        className="cctv_check"
                                                        label='CCTV Check'
                                                        checked={aspect.cctv_check}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'cctv_check', e.target.checked)}
                                                    />
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name="cctv_check_date"
                                                        value={aspect.cctv_check_date}
                                                        disabled={!reportedIsEditing}
                                                        onChange={(e) => handleInputChange(index, 'cctv_check_date', e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                ))}
                            </Form.Group>
                        </div>
                        <hr />

                        <div className="accordion ship_head_wrap mt-3" id="wdAccordion">

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="wdetailsa">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#wdetails`}
                                        aria-expanded="false"
                                        aria-controls={`wdetails`}
                                    >
                                        Warehouse Details
                                    </button>
                                </h2>

                                <div
                                    id={`wdetails`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby="wdetailsa"
                                    data-bs-parent="#wdAccordion"
                                >
                                    <div className="accordion-body p-0">
                                        <div className='import_exportDV'>
                                            <Row className='up_reco_status storeloc'>
                                                <Col md={6} className="import_export_dv">
                                                    <div className='import_dv'>
                                                        <h6>Import</h6>
                                                        <Row>
                                                            <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                <h4>Breakdown</h4>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    placeholder=""
                                                                    name='breakdown'
                                                                    value={reportedStn?.breakdown || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('breakdown', e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col sm={6} className='reco_left recto_station mb-2'>
                                                                <h4>Location</h4>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='location'
                                                                    value={reportedStn?.location || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('location', e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                <h4>Delivery</h4>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    placeholder=""
                                                                    name='delivery'
                                                                    value={reportedStn?.delivery || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('delivery', e.target.value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                </Col>
                                                <Col md={6} className='p-0'>
                                                    <div className='export_dv'>
                                                        <h6>Export</h6>
                                                        <Row>
                                                            <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                <h4>Acceptance Time</h4>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    placeholder=""
                                                                    name='acceptance_time'
                                                                    value={reportedStn?.acceptance_time || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('acceptance_time', e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                <h4>Location</h4>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='storage_location'
                                                                    value={reportedStn?.storage_location || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('storage_location', e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col sm={12} className='reco_left recto_station'>
                                                                <h4>Build Up Time</h4>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    placeholder=""
                                                                    name='buildup_time'
                                                                    value={reportedStn?.buildup_time || ''}
                                                                    disabled={!reportedIsEditing}
                                                                    onChange={(e) => handleReportedFormChange('buildup_time', e.target.value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='recover_box import_exportDV'>
                            <Row className='up_reco_status storeloc'>
                                <Col md={6} className="import_export_dv">
                                    <h6>Import</h6>
                                    <Row>
                                        <Col sm={6} className='reco_left  recto_station mb-3'>
                                            <h4>Breakdown</h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='breakdown'
                                                value={reportedStn?.breakdown || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('breakdown', e.target.value)}
                                            />
                                        </Col>
                                        <Col sm={6} className='reco_left recto_station mb-2'>
                                            <h4>Location - Temp</h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='location'
                                                value={reportedStn?.location || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('location', e.target.value)}
                                            />
                                        </Col>

                                        <Col sm={6} className='reco_left  recto_station mb-2'>
                                            <h4>Delivery</h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='delivery'
                                                value={reportedStn?.delivery || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('delivery', e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6}>
                                    <h6>Export</h6>
                                    <Row>

                                        <Col sm={6} className='reco_left  recto_station mb-3'>
                                            <h4>Acceptance Time</h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='acceptance_time'
                                                value={reportedStn?.acceptance_time || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('acceptance_time', e.target.value)}
                                            />
                                        </Col>
                                        <Col sm={6} className='reco_left  recto_station mb-2'>
                                            <h4>Location - Temp </h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='storage_location'
                                                value={reportedStn?.storage_location || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('storage_location', e.target.value)}
                                            />
                                        </Col>
                                        <Col sm={12} className='reco_left recto_station'>
                                            <h4>Build Up Time</h4>
                                            <Form.Control
                                                type="date"
                                                placeholder=""
                                                name='buildup_time'
                                                value={reportedStn?.buildup_time || ''}
                                                disabled={!reportedIsEditing}
                                                onChange={(e) => handleReportedFormChange('buildup_time', e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div> */}


                        {/* <div className='recover_box mt-2'>
                            <Row className='up_reco_status storeloc'>
                                <Col sm={6} className='reco_left  recto_station mb-3'>
                                    <h4>Storage Location</h4>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        name='Storage Location'
                                        value={reportedStn?.storage_location || ''}
                                        disabled={!reportedIsEditing}
                                        onChange={(e) => handleReportedFormChange('storage_location', e.target.value)}
                                    />
                                </Col>
                                <Col sm={6} className='reco_left  recto_station mb-3'>
                                    <h4>Acceptance Time</h4>
                                    <Form.Control
                                        type="date"
                                        placeholder=""
                                        name='Acceptance Time'
                                        value={reportedStn?.acceptance_time || ''}
                                        disabled={!reportedIsEditing}
                                        onChange={(e) => handleReportedFormChange('acceptance_time', e.target.value)}
                                    />
                                </Col>
                                <Col sm={6} className='reco_left recto_station'>
                                    <h4>Build Up Time</h4>
                                    <Form.Control
                                        type="date"
                                        placeholder=""
                                        name='Build Up Time'
                                        value={reportedStn?.buildup_time || ''}
                                        disabled={!reportedIsEditing}
                                        onChange={(e) => handleReportedFormChange('buildup_time', e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </div> */}

                        {/* <div className='ship_head_wrap'>
                            <div className='ship_head mb-0 mt-3'>
                                <h4>Documents Checklist </h4>
                            </div> */}
                        <div className="accordion ship_head_wrap mt-3" id="documentChecklistAccordion">

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingDocs">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseDocs"
                                        aria-expanded="false"
                                        aria-controls="collapseDocs"
                                    >
                                        Documents Checklist
                                    </button>
                                </h2>

                                <div
                                    id="collapseDocs"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingDocs"
                                    data-bs-parent="#documentChecklistAccordion"
                                >
                                    <div className="accordion-body p-0">
                                        <table className="table">
                                            <tbody>
                                                {attHandler?.length > 0 && attHandler.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    // console.log("🚀 ~ {files.map ~ file:", file)
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    <div key={`ns_${index}`} className=''>
                                                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_ext)
                                                                            ? (
                                                                                <>
                                                                                    <img
                                                                                        src={file.file_path}
                                                                                        alt="Preview"
                                                                                        style={{
                                                                                            maxWidth: "35px",
                                                                                            maxHeight: "35px",
                                                                                            marginRight: "10px",
                                                                                            backgroundColor: "#F1F1F1",
                                                                                            padding: "9px",
                                                                                            borderRadius: "3px"
                                                                                        }}
                                                                                    // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                    // onClick={() =>
                                                                                    //   handleFileClick(file.file_path)
                                                                                    // }
                                                                                    />
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <span className="">
                                                                                        <img src={Docmnt} className="fileimg" />
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        <span className="rafilename">
                                                                            {baseName?.length <= 12 ? fileName : `${baseName?.substring(0, 12)}... .${extension}`}
                                                                        </span>
                                                                        {/* <button
                                                                                    className="dltbtn"
                                                                                    type="button"
                                                                                    onClick={() =>
                                                                                        handleDeleteImage(index, file.id, file.attachment_type)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCircleXmark} />
                                                                                </button> */}
                                                                    </div>
                                                                </td>
                                                                <td className='nrml_text'>{file.category.map(key => cat[key] ?? key)}</td>
                                                                <td><img src={file_download} alt='file_download' onClick={() => handleDownload(file.file_path, file.file_name)} /></td>
                                                            </tr>
                                                        </>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div></div>
                </Col>
            </Row>
        </>
    )
}

export default Overview